<div class="container-fluid main pb-5" *ngIf="!isNull">
    <div class="container-xxxl pt-5 pt-md-5 mb-md-5">
        <div class="row mt-xl-5">
            <div class="col-xl-4">
                <div class="left">
                    <h2 class="occurs-common-title fs-5 fs-md-3 fw-bold lh-sm text-blue">
                        {{ mainArticle?.title }}
                    </h2>
                    <div class="occurs-common-under-text me-xl-5 fs-md-18" [innerHTML]="mainArticle?.bodyText"></div>
                </div>
            </div>

            <div class="col-xl-8">
                <div class="mt-4 mt-xl-0 ms-xl-5">
                    <ol class="d-block d-md-flex d-print-flex list-unstyled mb-0">
                        <li *ngFor="let age of ages; let i = index" class="gard-flex-fill-column d-flex d-md-block d-print-block">
                            <div class="d-flex d-md-block d-print-block age-wrap">
                                <div class="svg-circle-bg my-0 mx-auto" [ngClass]="age.active ? 'active' : 'inactive'">
                                    <i class="{{ age.icon }}" role="img" [attr.aria-label]="age.title" title="{{ age.title }}"></i>
                                    <div class="hori-bar d-none d-md-block d-print-none" [ngClass]="{ highlighted: age.connected }" *ngIf="i < ages.length - 1"></div>
                                    <div class="vert-bar d-block d-md-none d-print-none" [ngClass]="{ highlighted: age.connected }" *ngIf="i < ages.length - 1"></div>
                                </div>
                                <div class="under" [ngClass]="age.active ? 'active' : 'inactive'">
                                    <div class="under-title fs-8 fs-md-6">
                                        {{ age.title }}
                                        <span *ngIf="age.active" class="sr-only">Selected</span>
                                    </div>
                                    <div class="under-under-age-range fs-8 fs-md-18">{{ age.year }}</div>
                                </div>
                            </div>
                        </li>
                    </ol>
                    <div class="svg-gray-center-line d-print-none"></div>
                    <div *ngIf="disease?.ageAtOnsetSnippet" class="lower-text mt-5 d-flex justify-content-center fs-md-18" [innerHtml]="onsetSnippetText"></div>
                    <div class="onset-footer">
                        <div class="fs-8 fs-md-6 text-center pt-4 mt-4 mb-0 mt-xl-0">
                            <span [innerText]="orphanetLinkHtml"></span>
                            <a class="text-link" [href]="orphanet" (click)="redirectToOrphanet($event)" target="_blank">Orphanet<i class="icon-gard-open-link"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
